/**
 * @generated SignedSource<<9d22582e68d704ecd269a884615f2002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SafetyCheckForm_User$data = {
  readonly DiscordAuth: {
    readonly hasConnectedDiscordAccount: boolean;
    readonly hasJoinedDiscordServer: boolean | null;
  } | null;
  readonly id: string;
  readonly twitterName: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectDiscordButton_User" | "ConnectInstagramButton_User" | "ConnectTwitterButton_User" | "DiscordAuthModals_User">;
  readonly " $fragmentType": "SafetyCheckForm_User";
};
export type SafetyCheckForm_User$key = {
  readonly " $data"?: SafetyCheckForm_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SafetyCheckForm_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SafetyCheckForm_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitterName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DiscordAuth",
      "kind": "LinkedField",
      "name": "DiscordAuth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasConnectedDiscordAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasJoinedDiscordServer",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectDiscordButton_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectInstagramButton_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectTwitterButton_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscordAuthModals_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2f5dac2cfcf3d8bdbd33394b2f249e80";

export default node;
